<div class="rounded-lg border px-4 py-3 text-sm mt-5" [class]="toneClass()">
  <ng-content />
</div>
  